<header mat-dialog-title>
  <div class="dialog-header">
    <h3 class="mat-h2">Notificar toma de asistencia</h3>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</header>
<mat-dialog-content
  style="height: calc(100vh - 224px);max-height: calc(100vh - 224px);min-height: calc(100vh - 224px);">
  <h4 class="mat-h4">Materias a notificar <span class="opacity-medium"><em>Los responsables de las siguientes materias
        recibirán esta notificación</em></span></h4>
  <div style="height: 120px; overflow-y: auto; overflow-x: hidden;">
    <mat-chip-set>
      <mat-chip *ngFor="let materia of materias" disabled>  {{materia.nombre}}</mat-chip>
    </mat-chip-set>
  </div>
  <h3 class="mat-h3" style="margin-top: 16px">Contenido de la notificación</h3>
  <div class="message-container">
    <div class="message-mod">
      <p class="opacity-medium"><em>Use el siguiente campo de texto para personalizar el contenido de esta notificación</em></p>
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Mensaje personalizado</mat-label>
        <textarea matInput [formControl]="text"></textarea>
        <mat-hint align="start"><strong>Deje el campo vacío si desea enviar la notificación por defecto.</strong> </mat-hint>
      </mat-form-field>
    </div>
    <div class="message-template">
      <p class="opacity-medium"><em>Previsualización</em></p>
      <table width="100%" height="100%" cellspacing="0"
        style="font-family:Arial, Verdana, Geneva, Tahoma, sans-serif; border: none;">
        <tr>
          <td valign="top">
            <table
              style="width: 100%; max-width: 800px; margin: 0; border: solid 1px #ddd; border-radius: 6px; overflow:hidden;"
              cellspacing="0">
              <tr style="background: #61358c">
                <td style="font-weight: bold; font-size:26px; text-align: left; color: white; padding: 16px;">
                  Registro de asistencia
                </td>
                <td style="text-align: right; padding: 16px">
                  <img src="https://w3miglm.blob.core.windows.net/com/wwwInternals/Logo%20GLM/glm-logo.png" width="72px" height="auto">
                </td>
              </tr>
              <tr style="background: white">
                <td colspan="2" style="padding: 16px">
                  <p>
                    Estimado profesor
                    <!-- Estimad{{genero}} {{profesor}} -->
                  </p>
                  <p *ngIf="text.value !== ''; else default">
                    {{text.value}}
                  </p>
                  <ng-template #default>
                    <p>
                      No se encontró registro de asistencia de <strong>su materia</strong> el día
                      <strong>{{fechaAsistencia}}</strong>.
                    </p>
                    <p>
                      Recuerde que la asistencia se debe registrar durante la clase. Por favor haga el registro usando
                      el siguiente enlace:</p>
                    <p>
                      <strong>link personalizado</strong>
                      <!-- <strong>{{link}}</strong> -->
                    </p>
                  </ng-template>
                  <p>--------</p>
                  <p>
                    Atentamente,
                  </p>
                  <p>
                    <b>MiGLM</b>
                    <br>
                  </p>
                </td>
              </tr>
              <tr style="background: #ccc">
                <td colspan="2" style="padding: 16px">
                  <small>mi.glm.edu.co</small>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <mat-progress-bar *ngIf="saving$ | async" mode="indeterminate"></mat-progress-bar>
  <button style="margin-right: 4px;" mat-button color="primary" mat-dialog-close i18n="@@cerrar">Cerrar</button>
  <button mat-raised-button color="primary" (click)="notificar()" [disabled]="saving$ | async">Enviar</button>
</mat-dialog-actions>
